import scrollToDiv from '../util/scroll-to-div';

const $ = jQuery;

export default class SingleProductsRoute {
  constructor() {
    this.$window = $(window);
    this.$box = $('.product__body aside');
    this.boxFromTop = this.$box.length !== 0 ? this.$box.offset().top : false;

    if (this.$box.length !== 0) {
      this.scrolling();
    }

    this.addEvents();
    this.modifyDOM();
  }

  addEvents() {
    $('body').on('click', '.relatedItemsToggler', this.toggleAccessories);
    $('body').on('click', '.go-to-accessories', this.scrollToAccessories);

    if (this.$box.length !== 0) {
      this.$window.on('scroll', this.scrolling.bind(this));
    }
  }

  modifyDOM() {
  }

  toggleAccessories() {
    const prevText = $(this).text();
    const nextText = $(this).data('text');
    $(this).text(nextText);
    $(this).data('text', prevText);
    $('.relatedItems').toggleClass('expanded');
    return false;
  }

  scrollToAccessories() {
    scrollToDiv($('.relatedItems'), undefined, 'top', 200);
    return false;
  }

  scrolling() {
    if (this.$window.outerWidth() > 767) {
      const st = this.$window.scrollTop() + 150;
      const scrollStop = $('.scrollStop').offset().top - this.$box.outerHeight();
      // If sidebar is higher than the screen. Dont make the sidebar "stickish"
      if ( this.$box.outerHeight() > this.$window.outerHeight()) {
        return;
      }

      if (st > this.boxFromTop && st < scrollStop ) {
        this.$box.css('top', st - this.boxFromTop);
      }
    }
  }
}
